<div [ngClass]="{ active: active }" class="user-item-container">
  <div class="user-item-top-container">
    <div [style.background-image]="imageCode ? 'url(\'../../../../assets/images/flags/' + imageCode + '.svg\')' : null" class="country-badge"></div>
    <div class="user-name">{{ item.userData?.fullName }}</div>
  </div>
  <div class="user-item-bottom-container">
    <div class="label-span flex-2 department">
      <label>Department</label>
      <span>{{ item.userData.department }}</span>
    </div>
    <div class="label-span flex-1">
      <label>GID</label>
      <span>{{ item.id || item.userData.id }}</span>
    </div>
  </div>

  @if (item.isExternal) {
    <fa-icon [icon]="['fas', 'plus-circle']"></fa-icon>
  }
</div>
